module.exports = __webpack_public_path__ + "img/t3-silver.44a15a03.png";